import React, { Component, useState, useEffect, useRef } from 'react';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { Col, Row, Button, Input, Space, Table } from 'antd';
import Highlighter from 'react-highlight-words';

export const DataList = () => {
    const [isProgress, setProgress] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        console.log('handleSearch', selectedKeys, confirm, dataIndex);
        confirm();
        //setSearchText(selectedKeys[0]);
        //setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),            
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'Date',
            dataIndex: 'Date',
            key: 'Date',         
            ...getColumnSearchProps('Date'),
        }, {
            title: 'Export Company',
            dataIndex: 'Export_Company',
            key: 'Export_Company',
            ...getColumnSearchProps('Export_Company'),
        }, {
            title: 'Import Country',
            dataIndex: 'Import_Country',
            key: 'Import_Country',
            ...getColumnSearchProps('Import_Country'),
        }, {
            title: 'Import Company',
            dataIndex: 'Import_Company',
            key: 'Import_Company',
            ...getColumnSearchProps('Import_Company'),
        }, {
            title: 'Import Company Address',
            dataIndex: 'Import_Company_Address',
            key: 'Import_Company_Address',
            ...getColumnSearchProps('Import_Company_Address'),
        }, {
            title: 'Description',
            dataIndex: 'Description_Of_Goods',
            key: 'Description_Of_Goods',
            ...getColumnSearchProps('Description_Of_Goods'),
        }, {
            title: 'Quantity',
            dataIndex: 'Quantity',
            key: 'Quantity',
            ...getColumnSearchProps('Quantity'),
        }, {
            title: 'Price (USD)',
            dataIndex: 'Price_USD',
            key: 'Price_USD',
            ...getColumnSearchProps('Price_USD'),
        }, {
            title: 'Value (USD)',
            dataIndex: 'Value_USD',
            key: 'Value_USD',
            ...getColumnSearchProps('Value_USD'),
        }, {
            title: 'Price Conditions',
            dataIndex: 'Price_Conditions',
            key: 'Price_Conditions',
            ...getColumnSearchProps('Price_Conditions'),
        },
    ];

    useEffect(() => {
        getList();
    }, []);

    const getList = async (e) => {
        setProgress(true);
        try {
            const res = await fetch("/dataupload");

            if (res.ok) {
                setDataSource([]);
                res.json().then(v => {
                    setDataSource(v);
                    setProgress(false);
                }).then(() => {
                    console.log(dataSource);
                });
                
            } else {
                setProgress(false);
                alert('Error occurred');
            }
        } catch (ex) {
            setProgress(false);
            console.log("error", ex.toString());
        } finally {            
            console.log("test");
        }
    }

    return (
        <>
            <Row style={{ marginTop: 30 + 'px' }}>
                <Col span={24}>
                    <Table dataSource={dataSource} columns={columns} loading={isProgress } />
                </Col>
            </Row>
        </>
    );
};